import axios from 'axios';

/* eslint-disable no-shadow */
const state = {
  types: [],
};

const mutations = {
  SET_TYPES(state, types) {
    state.types = types;
  },
};

const actions = {
  getTypes({ commit }) {
    axios.get(`${process.env.VUE_APP_API_URL}/salary-types`)
      .then(response => commit('SET_TYPES', response.data))
      .catch(error => console.log(error));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
